import { ajaxURL, currentUserName, currentUserId } from './variables.js';

window.addEventListener('DOMContentLoaded', () => {

    document.addEventListener('click', (e) => {
        const clickedElement = e.target;
        const anchorLink = clickedElement.closest('.recommendation__list-item-edits-message');

        if (anchorLink) {
            e.preventDefault();
            const postID = anchorLink.getAttribute('data-postid');
            const userID = anchorLink.getAttribute('data-userid');
            const matchedPostID = anchorLink.getAttribute('data-matched-postid') || '';
            const receiverID = anchorLink.getAttribute('data-receiverid');
            const type = anchorLink.getAttribute('data-type');

            const relationshipKey = anchorLink.getAttribute('data-relationshipkey'); // ✅ USE RELATIONSHIP_KEY
            fetchMessages(postID, userID, matchedPostID, relationshipKey);
        }

        const archiveLink = clickedElement.closest('.recommendation__list-item-edits-delete');
        if (archiveLink) {
            e.preventDefault();
            const relationshipKey = archiveLink.getAttribute('data-relationshipkey'); // ✅
            archiveMessage(relationshipKey);
        }

        const unarchiveLink = clickedElement.closest('.recommendation__list-item-edits-unarchive');
        if (unarchiveLink) {
            e.preventDefault();
            const relationshipKey = unarchiveLink.getAttribute('data-relationshipkey'); // ✅
            unarchiveMessage(relationshipKey);
        }
    });

    function fetchMessages(postID, userID, matchedPostID, relationshipKey) {
        const data = new FormData();
        data.append('action', 'da_get_message');
        data.append('postID', postID);
        data.append('matchedPostID', matchedPostID);
        data.append('relationship_key', relationshipKey); // ✅

        fetch(ajaxURL, { method: 'POST', body: data })
            .then(res => res.json())
            .then(data => {
                if (data.success && Array.isArray(data.messages)) {
                    let modal = createMessageModal(data.messages, relationshipKey, postID, data.isArchived, data.archivedByUserId, currentUserId, matchedPostID);
                    document.body.appendChild(modal);
                    const wrapper = modal.querySelector('.messageBoardWrapper');
                    wrapper.scrollTop = wrapper.scrollHeight;
                    document.querySelectorAll(`a.recommendation__list-item-edits-message[data-relationshipkey="${relationshipKey}"] .unread-badge`)
                    .forEach(badge => badge.remove());
                  
                    markMessagesAsRead(relationshipKey);
                } else {
                    console.error('Fetch error:', data);
                }
            }).catch(console.error);
    }

    function archiveMessage(key) {
        const data = new FormData();
        data.append('action', 'da_archive_message');
        data.append('relationship_key', key); // ✅
        data.append('action_type', 'archive');
        fetch(ajaxURL, { method: 'POST', body: data })
            .then(res => res.json())
            .then((data) => {
                console.log('Archived successfully');
                console.log(data);
                window.location.reload();
            })
            .catch(console.error);
    }

    function unarchiveMessage(key) {
        const data = new FormData();
        data.append('action', 'da_archive_message');
        data.append('relationship_key', key); // ✅
        data.append('action_type', 'unarchive');
        fetch(ajaxURL, { method: 'POST', body: data })
            .then(res => res.json())
            .then((data) => {
                console.log('Unarchived successfully');
                console.log(data);
                window.location.reload();
            })
            .catch(console.error);
    }

    function markMessagesAsRead(key) {
        const data = new FormData();
        data.append('action', 'da_mark_messages_read');
        data.append('relationship_key', key); // ✅
        fetch(ajaxURL, { method: 'POST', body: data })
            .then(res => res.json())
            .then(console.log)
            .catch(console.error);
    }

    document.addEventListener('submit', (e) => {
        const form = e.target;
        if (!form.classList.contains('messageForm')) return;
        e.preventDefault();
        const message = form.querySelector('textarea[name="message"]').value.trim();

        console.log('Form submitted:', message);

        if (!message) return form.querySelector('textarea').classList.add('error');

        const formData = new FormData(form);
        formData.append('action', 'da_send_message');
        formData.append('userID', form.getAttribute('data-userid'));
        formData.append('relationship_key', form.getAttribute('data-relationshipkey')); // ✅
        formData.append('postID', form.getAttribute('data-postid'));

        fetch(ajaxURL, { method: 'POST', body: formData })
            .then(res => res.json())
            .then(data => {
                console.log('Message sent:', data);
                if (data.success) {
                    const wrapper = form.closest('.da__modal-inner-content').querySelector('.messageBoardWrapper');
                    const content = wrapper.querySelector('.messageBoardWrapper-content');
                    content.innerHTML += getMsgTempl(message, currentUserName, 'da-message-right', new Date().toISOString());
                    wrapper.scrollTop = wrapper.scrollHeight;
                    form.reset();
                } else {
                    console.error('Error sending message:', data);
                }
            })
            .catch(console.error);
    });

    function createMessageModal(messages, key, postID, isArchived, archivedBy, userID, matchedPostID) {
        let msgHTML = messages.map(msg => getMsgTempl(msg.message_text, msg.sender_name, msg.sender_id == currentUserId ? 'da-message-right' : 'da-message-left', msg.timestamp)).join('');
        const modal = document.createElement('div');
        modal.className = 'da__modal active recommendation__list-item-edits-message-modal';
        modal.innerHTML = `
            <div class="da__modal-content da__modal-content-message" style="max-width:800px;">
                <div class="da__modal-inner-wrapper">
                    <div class="da__modal-inner">
                        <button class="da__modal-close-btn">×</button>
                        <div class="da__modal-inner-content">
                            <div class="messageBoardWrapper">
                                <div class="default__message"><strong>
                                    Guten Tag,<br>
                                    wie wir Sie bereits informierten, stellen Ihr Gesuch und Ihr Angebot einen Match dar.<br>
                                    Bitte treten Sie hier über unsere Chatfunktion miteinander in Kontakt, klären Sie den jeweiligen Bedarf, den Preis und die weitere Vorgehensweise.<br>
                                    Wir wünschen Ihnen viel Erfolg,<br>
                                    Ihr Team von Ökopunktemarkt
                                </strong></div>
                                <div class="messageBoardWrapper-content">${msgHTML}</div>
                            </div>
                            <form class="messageForm" data-relationshipkey="${key}" data-userid="${userID}" data-postid="${postID}" style="${isArchived ? 'display:none;' : ''}">
                                <textarea name="message" placeholder="Ihre Nachricht" required></textarea>
                                <button type="submit">Nachricht senden</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>`;

        modal.addEventListener('click', (e) => {
            if (e.target.closest('.da__modal-close-btn')) {
                modal.remove();
                window.location.reload();
            }
        });

        return modal;
    }

    function getMsgTempl(msg, sender, cls, timestamp) {
        const d = new Date(timestamp);
        const dateStr = `${d.getDate()}.${d.getMonth() + 1}.${d.getFullYear()} ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
        return `
            <div class="messageBoard ${cls}">
                <div class="message__content">
                    <p class="message__posted-meta">
                        <span class="message__posted-time">${dateStr}</span>
                        <span class="message__posted-author">${sender}:</span>
                    </p>
                    <div>${msg}</div>
                </div>
            </div>`;
    }
});
